<div class="config-container shadow my-3">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse()">
    {{ planOrGroup.name }}
    {{ getPlanNames() }}
  </h4>

  <div class="collapse-block" *ngIf="collapseIsVisible">
    <div class="container-fluid">
      <!-- Matériaux -->
      <div>
        <div class="row">
          <div>
            <h4 class="title configurator-subtitle">
              {{ 'workbench.colors.materials' | translate }}
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="configurator-cards-container blocked-size">
            <div
              class="configurator-card"
              [ngClass]="{
                active: isMaterialSelected(material.id),
                disabled: !material.selectable,
              }"
              *ngFor="let material of materialsWithRestrictions"
              (click)="selectMaterial(material)">
              <ng-casto-img-loader
                [imgSrc]="workbenchService.apiUrl + material.icon.path"
                [imgClass]="'configurator-card-img'"></ng-casto-img-loader>
              <p class="configurator-card-title">{{ material.name }}</p>
            </div>
            <ng-casto-loader *ngIf="materials === null"></ng-casto-loader>
          </div>
        </div>

        <div *ngIf="materialSelected?.materialType === MaterialTypeEnum.Quartz">
          <h4 class="title configurator-subtitle">{{ 'workbench.colors.idf' | translate }}</h4>
          <div class="d-flex">
            <span class="mr-2">{{ 'workbench.colors.no' | translate }}</span>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                [(ngModel)]="configuration.inIdf"
                class="custom-control-input"
                id="customSwitch2" />
              <label class="custom-control-label" for="customSwitch2">{{ 'workbench.colors.yes' | translate }}</label>
            </div>
          </div>
        </div>
      </div>
      <!-- Epaisseur -->
      <div *ngIf="materialSelected != null">
        <div class="row">
          <div>
            <h4 class="title configurator-subtitle">
              {{ 'workbench.colors.thickness' | translate }}
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="configurator-cards-container blocked-size">
            <div
              class="configurator-card"
              [ngClass]="{
                active: isMaterialThicknessSelected(materialThickness.id),
              }"
              *ngFor="let materialThickness of getMaterialThicknessWithRestrictions()"
              (click)="selectMaterialThickness(materialThickness)">
              <ng-casto-img-loader
                [imgSrc]="workbenchService.apiUrl + materialThickness.icon.path"
                [imgClass]="'configurator-card-img'"></ng-casto-img-loader>
              <p class="configurator-card-title">{{ materialThickness.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Color -->
      <div *ngIf="materialThicknessSelected != null">
        <div class="row">
          <div>
            <h4 class="title configurator-subtitle">
              {{ 'workbench.colors.color' | translate }}
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="configurator-cards-container blocked-size">
            <div
              class="configurator-card"
              [ngClass]="{
                active: isColorSelected(color.id),
                disabled: color.disabled,
              }"
              *ngFor="let color of getColorsWithRestrictionsToDisplay()"
              (click)="selectColor(color)">
              <ng-casto-img-loader
                [imgSrc]="workbenchService.apiUrl + color.icon.path"
                [imgClass]="'configurator-card-img'"></ng-casto-img-loader>
              <p class="configurator-card-title">{{ color.range.name }} - {{ color.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
